import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { PAGES } from 'constants/pages';
import { TotadminPermission } from 'data/__generated__';

import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { CategoriesList } from './components/CategoriesList';

export const Categories = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.categories} />
                </HeaderTitle>
                <ButtonsContainer>
                    <Link to="/category/create">
                        <TotemPrimaryButton requiredPermissions={[TotadminPermission.CategoriesManage]}>
                            Créer une catégorie
                        </TotemPrimaryButton>
                    </Link>
                </ButtonsContainer>
            </Header>
            <Content>
                <ListContainer>
                    <CategoriesList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
